export default __webpack_public_path__ + "static/media/guy-podjarny.d60602dc.jpg";